//  IEModal selectors

export const getIsAlreadyShown = state => {
  return state.isAlreadyShown;
};
